import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { Heart, Hand } from "lucide-react";

export default function Values() {
  const { t } = useApp();
  const [data, setData] = useState(null);

  useEffect(() => { getContent("values").then(setData); }, []);

  return (
    <div className="space-y-6 fade-in" data-testid="values-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Heart className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.values}</h1>
          <p className="text-sm text-nour-text2">Piliers et valeurs de l&apos;Islam</p>
        </div>
      </header>

      <section>
        <h2 className="font-heading text-xl font-bold mb-3">{t.pillars}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="pillars-grid">
          {data?.pillars?.map(p => (
            <article key={p.id} className="nour-card p-5 flex gap-4" data-testid={`pillar-${p.id}`}>
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-emerald-100 flex items-center justify-center shrink-0">
                <span className="font-heading font-bold text-nour-primary">{p.id}</span>
              </div>
              <div>
                <div className="font-arabic-quran text-2xl text-nour-primary" dir="rtl">{p.name_ar}</div>
                <div className="font-heading font-semibold mt-1">{p.name_fr}</div>
                <p className="text-sm text-nour-text2 mt-1">{p.desc_fr}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="pt-3">
        <h2 className="font-heading text-xl font-bold mb-3">{t.moral_values}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="values-grid">
          {data?.values?.map(v => (
            <article key={v.id} className="nour-card p-5" data-testid={`value-${v.id}`}>
              <div className="flex items-center gap-2 mb-2">
                <Hand className="w-4 h-4 text-nour-primary" />
                <div className="font-heading font-semibold">{v.name_fr}</div>
              </div>
              <div className="font-arabic-quran text-xl text-nour-primary" dir="rtl">{v.name_ar}</div>
              <p className="text-sm text-nour-text2 mt-2">{v.desc_fr}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
